import { useSelector } from 'react-redux';
import ProductDisclaimers from '@app/components/pages/pdp/ProductDisclaimers';

const Disclaimers = () => {
  const taxDisclaimerMessageFooter = useSelector(
    s => s.orders?.taxDisclaimerMessageFooter
  );
  const isQuantityMergeEnabled = useSelector(
    s => s?.common?.isQuantityMergeEnabled
  );

  return (
    <ProductDisclaimers
      isQuantityMergeEnabled={isQuantityMergeEnabled}
      taxDisclaimerMessageFooter={taxDisclaimerMessageFooter}
    />
  );
};

export default Disclaimers;
